import { LocaleObject } from "yup";
import { __ } from "@wordpress/i18n";

/**
 * Localization configuration for Yup validation messages.
 * Reuses the same Portuguese (Portugal) wording as every other simulator's
 * ValidationsLocale.tsx (e.g. `mac`), so the same term isn't translated
 * two different ways across the plugin.
 */
export const validationsLocale: LocaleObject = {
    mixed: {
        default: __("Valor inválido.", "df-simulators"),
        required: __("Este campo é obrigatório.", "df-simulators"),
        oneOf: ({ values }) =>
            __(
                `Deve ser um dos seguintes valores: ${values.join(", ")}.`,
                "df-simulators"
            ),
        notOneOf: ({ values }) =>
            __(
                `Não pode ser um dos seguintes valores: ${values.join(", ")}.`,
                "df-simulators"
            ),
    },
    string: {
        length: ({ length }) =>
            __(`Deve ter exatamente ${length} caracteres.`, "df-simulators"),
        min: ({ min }) =>
            __(`Deve ter pelo menos ${min} caracteres.`, "df-simulators"),
        max: ({ max }) =>
            __(`Deve ter no máximo ${max} caracteres.`, "df-simulators"),
    },
    number: {
        min: ({ min }) =>
            __(`O valor deve ser no mínimo ${min}.`, "df-simulators"),
        max: ({ max }) =>
            __(`O valor deve ser no máximo ${max}.`, "df-simulators"),
        lessThan: ({ less }) =>
            __(`O valor deve ser menor que ${less}.`, "df-simulators"),
        moreThan: ({ more }) =>
            __(`O valor deve ser maior que ${more}.`, "df-simulators"),
        positive: __("O valor deve ser um número positivo.", "df-simulators"),
        negative: __("O valor deve ser um número negativo.", "df-simulators"),
        integer: __("O valor deve ser um número inteiro.", "df-simulators"),
    },
};
